import { gql } from "@apollo/client";

export const SEND_EMAIL = gql`
  mutation sendEmail(
    $fullname: String!
    $emailFrom: String!
    $accountID: String!
    $address: String!
    $subject: String!
    $content: String!
  ) {
    sendSupportEmail(
      data: {
        fullname: $fullname
        emailFrom: $emailFrom
        accountID: $accountID
        address: $address
        subject: $subject
        content: $content
      }
    )
  }
`;

export const SEND_EMAIL_WITH_RECIPIENT = gql`
  mutation sendEmailWithRecipient(
    $fullname: String!
    $emailFrom: String!
    $accountID: String!
    $address: String!
    $subject: String!
    $content: String!
    $recipient: String!
  ) {
    sendSupportEmail(
      data: {
        fullname: $fullname
        emailFrom: $emailFrom
        accountID: $accountID
        address: $address
        subject: $subject
        content: $content
        recipient: $recipient
      }
    )
  }
`;

export const SEND_DONATION_FORM = gql`
  mutation SendDonationEmail($data: DonationEmailInput!) {
    sendDonationEmail(data: $data)
  }
`;
